import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const virtualAgentStandardFlowsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtual-agent-standard-flows',
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows',
	exact: true,
};
